import {
  Component,
  ViewEncapsulation,
  OnInit,
  Inject, AfterViewInit, ViewChild
} from '@angular/core';

import {
  FormBuilder,
  Validators,
  FormGroup,
  FormControl
} from '@angular/forms';
import { process } from '@progress/kendo-data-query';
import * as moment from 'moment';
import {
  MAT_DIALOG_DATA, MatDialogRef, MatSnackBar
} from '@angular/material';
import * as uuidv4 from 'uuid/v4';
import {UserContext} from "../../services/user-context";
import {Observable} from 'rxjs';
import {
  DataStateChangeEvent,
  GridComponent,
  GridDataResult,
  RemoveEvent,
  SelectionEvent
} from '@progress/kendo-angular-grid';
import {State} from '@progress/kendo-data-query';
import {ShopifyService} from '../../services/shopify/shopify.service';
import {ExerciseService} from '../../services/exercise/exercise.service';
import {Collection} from '../../models/collection.model';
import {Variant} from '../../models/variant.model';
import {AssetService} from '../../services/assets/assets.service';

@Component({
  selector: 'app-note-dialog',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'note-dialog.template.html',
  styles: [
    "app-note-dialog .k-dialog-content {padding:0;margin:0;}",
    "app-note-dialog .mat-expansion-panel-body {padding:0;}",
    "app-note-dialog mat-dialog-container {padding:0;}",
    "app-note-dialog mat-dialog-content.mat-dialog-content {background:#f7fafc;padding:24px;}",
    "app-note-dialog mat-dialog-actions {display:flex;flex-direction: row;justify-content: space-between;}",
    "app-note-dialog .k-checkbox {background: #ff6358;opacity: 0.6;}"
  ]
})

export class NoteDialogComponent implements OnInit {
  @ViewChild('productGrid',{static:false}) private productGrid:GridComponent;

  public form: FormGroup;
  public formErrors = {
    author: '',
    subject: '',
    text: ''
  };
  public productView: Observable<GridDataResult>;
  public exerciseView: Observable<GridDataResult>;
  public note: any;
  live = false;
  selectedProductKeys:string[] = [];
  selectedExerciseKeys:string[] = [];
  productSearchTerm = '';
  selectedProducts:Variant[] = [];
  autoOpen = false;
  cartOpened = false;
  collection:Collection;

  types = ['simple','soap','assessment', 'consultation'];
  appointmentTypes = ['telehealth','clinic','office','home'];

  loading = false;
  public productState: State = {
    skip: 0,
    take: 5
  };
  public exerciseState: State = {
    skip: 0,
    take: 4
  };
  constructor(private formBuilder: FormBuilder,
              private snackBar: MatSnackBar,
              private assetService: AssetService,
              private userContext: UserContext,
              private shopifyService: ShopifyService,
              private exerciseService: ExerciseService,
              public dialogRef: MatDialogRef<NoteDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.productView = shopifyService;
    this.exerciseView = exerciseService;

    if ( (data || {}).id) {
      this.note = Object.assign({}, data);
    } else {
      this.note = {id: uuidv4(), meta: {}, type: data.type, time: new Date().toISOString(), author: this.userContext.user.name};
      this.live = data.live;
    }
    console.log("Note: " + JSON.stringify(this.note, null, 4));
  }

  public ngOnInit(): void {
    this.buildForm();

    /*
    this.shopifyService.getCollections().then((collections) => {
      this.collectionService.collectionObserver.next(collections);
    }).catch(err => alert(err));*/
  }

  public updateModel(value:any): void {
    console.log("Updating model..." + JSON.stringify(value));
    this.note.type = value;
    this.buildForm();
  }

  public productStateChange(state: DataStateChangeEvent): void {
    this.productState = state;
    this.getProducts();
  }


  public productFilter(inputValue: string): void {
    this.productSearchTerm = inputValue;
    this.productState.skip = 0;
    this.getProducts();
  }

  public exerciseStateChange(state: DataStateChangeEvent): void {
    this.exerciseState = state;
    const page = this.productState.skip / this.productState.take + 1;
    const limit = this.productState.take;

    this.exerciseService.getList(page, limit);
  }
  public getProducts() {
    //this.loading = true;
    const page = this.productState.skip / this.productState.take + 1;
    const limit = this.productState.take;

    this.collapseAll();
    this.shopifyService.getList(page, limit, this.productSearchTerm, this.collection);
  }
  public collapseAll() {
    for( let i = 0; i < this.productState.take; i++ ) {
      this.productGrid.collapseRow(i);
    }
  }

  public showCart() {
    this.cartOpened = true;
  }

  public closeCart() {
    this.cartOpened = false;
  }

  public removeCartHandler(event:RemoveEvent) {
    console.log("Data changed.");
    this.selectedProducts = this.selectedProducts.filter( p => p.id !== event.dataItem.id );
    this.assetService.unpublish("product", event.dataItem );
    this.selectedProductKeys = this.selectedProducts.map(p => p.id);
    this.collapseAll();
  }

  public variantSelected(event:SelectionEvent) {
    let deselected = event.deselectedRows.map(r => r.dataItem.id);
    this.selectedProducts = this.selectedProducts.filter( p => !deselected.includes(p.id) ).concat(event.selectedRows.map( r => r.dataItem));
    this.selectedProductKeys = this.selectedProducts.map(p => p.id);
    event.selectedRows.forEach( (row) => {
      this.assetService.publish("product", row.dataItem, this.autoOpen ? {open:true} : null);
      console.log("Publishing asset");
    });
    event.deselectedRows.forEach( (row) => {
      this.assetService.unpublish("product", row.dataItem );
    });
  }

  public onExerciseSelectionChanged(event:SelectionEvent) {
    event.selectedRows.forEach( (row) => {
      this.assetService.publish("exercise", row.dataItem );
    });
    event.deselectedRows.forEach( (row) => {
      this.assetService.unpublish("exercise", row.dataItem );
    });
  }

  public buildForm() {
    if( this.note.type === "simple") {
      this.form = this.formBuilder.group({
        type: new FormControl(this.note.type, [
          Validators.required,
        ]),

        author: new FormControl(this.note ? this.note.author : '', [
          Validators.required,
        ]),
        subject: new FormControl(this.note ? this.note.subject : '', [
          Validators.required,
        ]),
        text: new FormControl(this.note ? this.note.text : '', [
          Validators.required,
          Validators.minLength(3)
        ])
      });
    } else if( this.note.type === "soap") {
      let meta = this.note.meta || {};

      this.selectedProductKeys = (meta.products || []).map(p => p.id);
      this.selectedExerciseKeys = (meta.exercises || []).map(e => e.id);

      this.form = this.formBuilder.group({
        type: new FormControl(this.note.type, [
          Validators.required,
        ]),

        author: new FormControl(this.note ? this.note.author : '', [
          Validators.required,
        ]),
        subjective: new FormControl(meta.subjective, [
          Validators.required,
        ]),
        objective: new FormControl(meta.subjective, [
          Validators.required,
        ]),
        action: new FormControl(meta.action, [
          Validators.required
        ]),
        cart: new FormControl(false, [
        ]),
        open: new FormControl(false, [
        ]),
        prognosis: new FormControl(meta.prognosis, [
          Validators.required
        ]),
        revaluation: new FormControl(meta.revaluation ? new Date(meta.revaluation) :  moment().add(7, 'days').toDate(), [
        ]),
        appointment: new FormControl(meta.appointment, [
        ]),
        appointmentType: new FormControl(meta.appointmentType || 'telehealth', [
        ])
      });
    } else if( this.note.type === "consultation") {
      let meta = this.note.meta || {};

      this.selectedProductKeys = (meta.products || []).map(p => p.id);
      this.selectedExerciseKeys = (meta.exercises || []).map(e => e.id);

      this.form = this.formBuilder.group({
        type: new FormControl(this.note.type, [
          Validators.required,
        ]),

        author: new FormControl(this.note ? this.note.author : '', [
          Validators.required,
        ]),
        subjective: new FormControl(meta.subjective, [
          Validators.required,
        ]),
        objective: new FormControl(meta.subjective, [
          Validators.required,
        ]),
        action: new FormControl(meta.action, [
          Validators.required
        ]),
        cart: new FormControl(false, [
        ]),
        open: new FormControl(false, [
        ]),
        prognosis: new FormControl(meta.prognosis, [
          Validators.required
        ]),
        revaluation: new FormControl(meta.revaluation ? new Date(meta.revaluation) :  moment().add(7, 'days').toDate(), [
        ]),
        appointment: new FormControl(meta.appointment, [
        ]),
        appointmentType: new FormControl(meta.appointmentType || 'telehealth', [
        ])
      });
    } else if( this.note.type === "assessment") {
      let meta = this.note.meta || {};

      this.selectedProductKeys = (meta.products || []).map(p => p.id);
      this.selectedExerciseKeys = (meta.exercises || []).map(e => e.id);

      this.form = this.formBuilder.group({
        type: new FormControl(this.note.type, [
          Validators.required,
        ]),
        author: new FormControl(this.note ? this.note.author : '', [
          Validators.required,
        ]),
        concern: new FormControl(meta.concern, [
          Validators.required,
        ]),
        cart: new FormControl(false, [
        ]),
        open: new FormControl(false, [
        ]),
        careplanInClinic: new FormControl(meta.careplanInClinic, [
          Validators.required,
        ]),
        careplanOutClinic: new FormControl(meta.careplanOutClinic, [
          Validators.required,
        ]),
        progress: new FormControl(meta.progress, [
          Validators.required,
        ]),
        revaluation: new FormControl(meta.revaluation ? new Date(meta.revaluation) : moment().add(7, 'days').toDate(), [
        ]),
        appointment: new FormControl(meta.appointment, [
        ]),
        appointmentType: new FormControl(meta.appointmentType || 'telehealth', [
        ]),
        prognosis: new FormControl(meta.prognosis, [
          Validators.required
        ])
      });
    } else if( this.note.type === "followup") {
      let meta = this.note.meta || {};
      let intakeFollowup = meta.intakeFollowup || {};

      this.form = this.formBuilder.group({
        type: new FormControl(this.note.type, [
          Validators.required,
        ]),

        author: new FormControl(this.note ? this.note.author : '', [
          Validators.required,
        ]),
        visit: new FormControl(intakeFollowup.visit, [
          Validators.required,
        ]),
        compliance: new FormControl(intakeFollowup.compliance, [
          Validators.required,
        ])
      });
    } else if( this.note.type === "appointment") {
      let meta = this.note.meta || {};
      let intakeAppointment = meta.intakeAppointment || {};

      this.form = this.formBuilder.group({
        type: new FormControl(this.note.type, [
          Validators.required,
        ]),

        author: new FormControl(this.note ? this.note.author : '', [
          Validators.required,
        ]),
        visit: new FormControl(JSON.stringify(intakeAppointment.visit,null,4), [
          Validators.required,
        ]),
        conditions: new FormControl(JSON.stringify(intakeAppointment.conditions, null, 4), [
          Validators.required,
        ]),
        biometrics: new FormControl(JSON.stringify(intakeAppointment.biometrics, null, 4), [
          Validators.required,
        ]),
        compliance: new FormControl(JSON.stringify(intakeAppointment.compliance, null, 4), [
          Validators.required,
        ])
      });
    } else if( this.note.type === "registration") {
      let meta = this.note.meta || {};
      let intakeRegistration = meta.intakeRegistration || {};

      this.form = this.formBuilder.group({
        type: new FormControl(this.note.type, [
          Validators.required,
        ]),

        author: new FormControl(this.note ? this.note.author : '', [
          Validators.required,
        ]),
        visit: new FormControl(JSON.stringify(intakeRegistration.visit,null,4), [
          Validators.required,
        ]),
        contact: new FormControl(JSON.stringify(intakeRegistration.contact,null,4), [
          Validators.required,
        ]),
        insurance: new FormControl(JSON.stringify(intakeRegistration.insurance,null,4), [
          Validators.required,
        ]),
        goals: new FormControl( intakeRegistration.goals, [
          Validators.required,
        ]),
        medications: new FormControl(intakeRegistration.medications, [
          Validators.required,
        ]),
        target: new FormControl(intakeRegistration.target, [
          Validators.required,
        ]),
        lifestyles: new FormControl(intakeRegistration.lifestyles, [
          Validators.required,
        ]),
        treatments: new FormControl(intakeRegistration.treatments, [
          Validators.required,
        ]),
        conditions: new FormControl(JSON.stringify(intakeRegistration.conditions, null, 4), [
          Validators.required,
        ]),
        biometrics: new FormControl(JSON.stringify(intakeRegistration.biometrics, null, 4), [
          Validators.required,
        ]),
        compliance: new FormControl(JSON.stringify(intakeRegistration.compliance, null, 4), [
          Validators.required,
        ])
      });
    }
  }

  public collectionChange(value:Collection) {
    this.collection = value;
    console.log("Changed collection to: " + value.title);
    this.productState = {
      skip: 0,
      take: 5
    };
    this.getProducts();
  }

  public autoOpenChanged(event:boolean) {
    console.log("Auto open changed " + event);
    this.autoOpen = event;
  }

  public save() {
    if (this.note.type === "simple") {
      this.note = Object.assign(this.note, this.form.value);
      this.dialogRef.close(this.note);
    } else if ( this.note.type === "soap" ) {
      this.note.author = this.userContext.user.name;
      this.note.subject = "Clinical Update";
      this.note.meta = Object.assign(this.note.meta, this.form.value);
      this.note.meta.revaluation = this.note.meta.revaluation.toISOString();
      this.note.meta.products = this.selectedProducts;
      this.note.meta.cart = !!this.form.value.cart;
      this.note.meta.exercises = this.exerciseService.exercises.filter( e => this.selectedExerciseKeys.includes(e.id));
      if( this.note.meta.appointment ) {
        this.note.meta.providerId = this.userContext.user.reference;
        this.note.meta.provider = this.userContext.user.name;
      }
      this.dialogRef.close(this.note);
    } else if ( this.note.type === "assessment" ) {
      this.note.author = this.userContext.user.name;
      this.note.subject = "Clinical Assessment";
      this.note.meta = Object.assign(this.note.meta, this.form.value);
      this.note.meta.revaluation = this.note.meta.revaluation.toISOString();
      this.note.meta.cart = !!this.form.value.cart;
      this.note.meta.products = this.selectedProducts;
      this.note.meta.exercises = this.exerciseService.exercises.filter( e => this.selectedExerciseKeys.includes(e.id));
      if( this.note.meta.appointment ) {
        this.note.meta.providerId = this.userContext.user.reference;
        this.note.meta.provider = this.userContext.user.name;
      }
      this.dialogRef.close(this.note);
    }
  }

  public cancel() {
    this.dialogRef.close();
  }

}
